import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const ai_agents = {
  total_conversations: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/total_conversations",
      params,
    ),
  total_messages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/total_messages", params),
  new_conversations: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/new_conversations",
      params,
    ),
  unique_users: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/unique_users", params),
  adoption_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/adoption_rate", params),
  repeat_conversations: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/repeat_conversations",
      params,
    ),
  conversations_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/conversations_by_date",
      params,
    ),
  messages_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/messages_by_date",
      params,
    ),
  avg_messages_per_conversation: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/avg_messages_per_conversation",
      params,
    ),
  avg_messages_per_conversation_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/avg_messages_per_conversation_by_date",
      params,
    ),
  agent_usage_by_message: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/agent_usage_by_message",
      params,
    ),
  popular_day_and_time: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/popular_day_and_time",
      params,
    ),
  pause_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/pause_rate", params),
  resolution_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/resolution_rate", params),
  handoff_rate_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/handoff_rate_by_date",
      params,
    ),
  resolution_rate_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/resolution_rate_by_date",
      params,
    ),
  ai_workflows_actions_executed: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/ai_workflows_actions_executed",
      params,
    ),
  ai_workflows_filters_executed: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/ai_workflows_filters_executed",
      params,
    ),
  ai_workflow_usage_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/ai_workflow_usage_rate",
      params,
    ),
  estimated_time_saved: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/estimated_time_saved",
      params,
    ),
  top_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/top_members", params),
  conversations_by_country: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/conversations_by_country",
      params,
    ),
  ai_messages_by_space: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/ai_messages_by_space",
      params,
    ),
  conversation_duration: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/ai_agents/conversation_duration",
      params,
    ),
  actions_by_type: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/ai_agents/actions_by_type", params),
};
